/* eslint-disable @angular-eslint/directive-selector */
import { AfterViewInit, Directive, ElementRef, ViewContainerRef, inject, input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { StandardDecoratorComponent } from '../components/decorators/standard-decorator/standard-decorator.component';
import { Guid } from 'src/app/shared/utils';
import { DECORATOR_HOST, DecoratorHost } from './decorator-host';
import { CalculateValidationTextFn } from '../components/internal/control-supporting-text/control-supporting-text.component';
import { RightSideDecoratorComponent } from '../components/decorators/right-side-decorator/right-side-decorator.component';

@Directive({
  selector: '[decorator]',
  standalone: true
})
export class DecoratorDirective implements AfterViewInit {
  private viewContainerRef = inject(ViewContainerRef);
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private ngControl = inject(NgControl, { self: true, optional: true });
  private decoratorHost = inject<DecoratorHost | null>(DECORATOR_HOST, { self: true, optional: true });

  decorator = input<string>('');
  caption = input.required<string>();
  infoText = input<string>('');
  defaultInputId = Guid.newGuid();
  calculateValidationText = input<CalculateValidationTextFn | string>();

  ngAfterViewInit(): void {
    const element: HTMLElement = this.elementRef.nativeElement;
    const decorator = this.decorator();

    // Determine the input ID to use, prioritizing any existing ID from the host, then the default one if necessary
    const existingHostInputId = (this.decoratorHost?.getInputId() ?? '').trim();
    const generatedInputId = existingHostInputId || this.defaultInputId;
    if (!existingHostInputId) {
      this.decoratorHost?.setInputId(generatedInputId);
    }

    if (decorator === '' || decorator === 'standard') {
      const effectiveInputId = this.decoratorHost?.getInputId() ?? generatedInputId;
      const componentRef = this.viewContainerRef.createComponent(StandardDecoratorComponent, {
        projectableNodes: [[element]]
      });
      componentRef.setInput('caption', this.caption());
      componentRef.setInput('infoText', this.infoText());
      componentRef.setInput('control', this.ngControl?.control ?? null);
      componentRef.setInput('inputId', effectiveInputId);
      componentRef.setInput('calculateValidationText', this.calculateValidationText());
      componentRef.changeDetectorRef.detectChanges();
    }
    else if (decorator === 'right-side') {
      const effectiveInputId = this.decoratorHost?.getInputId() ?? generatedInputId;
      const componentRef = this.viewContainerRef.createComponent(RightSideDecoratorComponent, {
        projectableNodes: [[element]]
      });
      componentRef.setInput('caption', this.caption());
      componentRef.setInput('infoText', this.infoText());
      componentRef.setInput('control', this.ngControl?.control ?? null);
      componentRef.setInput('inputId', effectiveInputId);
      componentRef.setInput('calculateValidationText', this.calculateValidationText());
      componentRef.changeDetectorRef.detectChanges();
    }
  }
}
